import { useSelector } from "react-redux";
import { LbfProductApi } from "../../apis";
import { IGeneral } from "../../interfaces/IGeneral";
import { ISystemHistory } from "../../interfaces/ISystemHistory";
import { IReference } from "../../models/General";
import { dateSecFormat } from "../../utils/date";
import { renderName } from "../../utils/render-name";
import { ColumnType, Table } from "../table";
import RenderText from "../ui/render-text";

export function ProductSupplierLedHistoryList({ id }: { id: string }) {
  const { programHistoryTypes } = useSelector((state: { general: IGeneral }) => state.general);
  const columns = useHeader({ programHistoryTypes });

  return (
    <Table
      name="supplier-led-product-credit.list"
      columns={columns}
      filters={{ actionUserId: "", type: "", lbfProductId: id }}
      loadData={(data) => LbfProductApi.history(data!)}
    />
  );
}

const useHeader = ({ programHistoryTypes }: { programHistoryTypes: IReference[] }): ColumnType<ISystemHistory>[] => [
  {
    title: "#",
    width: "30px",
    render: (_r, index) => <RenderText text={index + 1} />,
  },
  {
    title: "Код",
    sorter: true,
    dataIndex: "productRefCode",
    render: (record) => <RenderText text={record?.productRefCode || "-"} />,
  },
  {
    title: "Системд хийсэн үйлдэл",
    sorter: true,
    dataIndex: "sku",
    render: (record) => <RenderText text={(programHistoryTypes || []).find((c: IReference) => c?.code === record?.type)?.name || "-"} />,
  },
  {
    title: "Төрөл",
    sorter: true,
    dataIndex: "type",
    render: (record) => <RenderText text={record.type ?? "-"} />,
  },
  {
    title: "Тайлбар",
    sorter: true,
    dataIndex: "description",
    render: (record) => <RenderText text={record.description || "-"} />,
  },
  {
    title: "Огноо, цаг",
    sorter: true,
    dataIndex: "createdAt",
    render: (record) => <RenderText text={dateSecFormat(record.createdAt)} />,
  },
  {
    title: "Хэрэглэгч",
    sorter: true,
    dataIndex: "actionUser",
    render: (record) => <RenderText text={renderName(record?.actionUser)} />,
  },
];
